// extracted by mini-css-extract-plugin
module.exports = {"componentsVouchersVoucherTabs":"styles_componentsVouchersVoucherTabs__2sM8Q"};